<template>
  <div class="vc-icon">
    <div class="vc-text" v-if="type ==='Brands'">
        Vendor
     </div>
     <div class="vc-icon-icon" v-else>
      <span>Sold By </span>
      <img src="@/assets/images/amazon.png" alt="vc-icon" class="vc-icon-img"/>
     </div>
   </div>
</template>

<script setup>
const { type } = defineProps(['type'])
</script>

<style scoped lang="less">
.vc-text {
  width: 59px;
  height: 20px;
 background-color: rgba(70, 130, 250, 0.1);
 color: #2B5099;
  text-align: center;
  line-height: 20px;
  box-shadow: 0 1px 0 0 #1a16250d;
 border-radius: 4px;
 font-size: 12px;
 font-weight: 600;
 letter-spacing: 0.3px;
 font-family: Sora-Medium;
}
.vc-icon-icon{
  font-family: Sora-Medium;
font-weight: 600;
font-size:12px;
color: #1B191A;
letter-spacing: 0;
display: flex;
align-items: center;
padding: 0 5px;
gap: 4px;
height: 20px;
background: #ff87191a;
border-radius: 4px;
.vc-icon-img{
  width: 39px !important;
  height: 16px !important;
  margin-right: 0px !important;
}
}

</style>